document.addEventListener('DOMContentLoaded', function() {
  const video = document.getElementById('heroVideo');
  const soundIcon = document.querySelector('.hero .sound-icon');
  const soundMute = document.querySelector('.hero .sound-mute');

  function toggleSoundClasses() {
    if (video.muted) {
      soundIcon.classList.add('hidden');
      soundMute.classList.remove('hidden');
    } else {
      soundIcon.classList.remove('hidden');
      soundMute.classList.add('hidden');
    }
  }

  document.getElementById('heroVideoVolume').addEventListener('click', function() {
    video.muted = !video.muted;
    toggleSoundClasses();
  });

  toggleSoundClasses();
});
